import { render, staticRenderFns } from "./crudReportSeller.vue?vue&type=template&id=6fc38fcc&scoped=true"
import script from "./crudReportSeller.vue?vue&type=script&lang=js"
export * from "./crudReportSeller.vue?vue&type=script&lang=js"
import style0 from "./crudReportSeller.vue?vue&type=style&index=0&id=6fc38fcc&prod&lang=css"
import style1 from "./crudReportSeller.vue?vue&type=style&index=1&id=6fc38fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc38fcc",
  null
  
)

export default component.exports